export default "__VITE_ASSET__DBWGSGct__"